import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const EducationCertifications = () => {
  const education = [
    {
      id: 1,
      institution: "",
      logo: "https://images.unsplash.com/photo-1562774053-701939374585?w=80&h=80&fit=crop",
      degree: "Bachelor of Science in Computer Science",
      duration: "2019 - 2023",
      location: "Ibadan, NG",
      gpa: "3.8/4.0",
      honors: "",
      coursework: [
        "Data Structures & Algorithms",
        "",
        "Database Systems",
        "Computer Networks",
        "Machine Learning"
      ]
    },
    {
      id: 2,
      institution: "CODARHQ",
      logo: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=80&h=80&fit=crop",
      degree: "Certificate in Web Development Program",
      duration: "2023",
      location: "Ikeja, LAG",
      description: "Intensive 6-month program focusing on scalable system design and microservices architecture."
    }
  ];

  const certifications = [
    {
      id: 1,
      name: "AWS Certified Solutions Architect",
      issuer: "Amazon Web Services",
      logo: "https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?w=60&h=60&fit=crop",
      issueDate: "March 2023",
      expiryDate: "March 2026",
      credentialId: "AWS-SAA-2023-001234",
      verificationUrl: "#",
      status: "Active"
    },
    {
      id: 2,
      name: "Google Cloud Professional Developer",
      issuer: "Google Cloud",
      logo: "https://images.unsplash.com/photo-1573804633927-bfcbcd909acd?w=60&h=60&fit=crop",
      issueDate: "January 2023",
      expiryDate: "",
      credentialId: "GCP-PD-2023-005678",
      verificationUrl: "#",
      status: "Active"
    },
    {
      id: 3,
      name: "Certified Kubernetes Administrator",
      issuer: "Cloud Native Computing Foundation",
      logo: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=60&h=60&fit=crop",
      issueDate: "September 2022",
      expiryDate: "September 2025",
      credentialId: "CKA-2022-009876",
      verificationUrl: "#",
      status: "Active"
    },
    {
      id: 4,
      name: "MongoDB Certified Developer",
      issuer: "",
      logo: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=60&h=60&fit=crop",
      issueDate: "June 2022",
      expiryDate: "June 2025",
      credentialId: "MDB-DEV-2022-112233",
      verificationUrl: "#",
      status: "Active"
    },
    {
      id: 5,
      name: "React Developer Certification",
      issuer: "Meta (Facebook)",
      logo: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=60&h=60&fit=crop",
      issueDate: "April 2022",
      expiryDate: "April 2024",
      credentialId: "META-REACT-2022-445566",
      verificationUrl: "#",
      status: "Expired"
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success/10 text-success';
      case 'Expired':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <section className="bg-surface py-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Education & Certifications
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Academic foundation and professional certifications that validate my expertise
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Education Section */}
          <div>
            <h3 className="text-2xl font-semibold text-foreground mb-6 flex items-center">
              <Icon name="GraduationCap" size={24} className="mr-3 text-primary" />
              Education
            </h3>
            
            <div className="space-y-6">
              {education?.map((edu) => (
                <div key={edu?.id} className="bg-background rounded-xl p-6 border border-border shadow-subtle">
                  <div className="flex items-start space-x-4 mb-4">
                    <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                      <Image
                        src={edu?.logo}
                        alt={`${edu?.institution} logo`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-semibold text-foreground mb-1">
                        {edu?.degree}
                      </h4>
                      <p className="text-primary font-medium mb-1">{edu?.institution}</p>
                      <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                        <span>{edu?.duration}</span>
                        <span>•</span>
                        <span>{edu?.location}</span>
                      </div>
                      {edu?.gpa && (
                        <div className="flex items-center space-x-4 text-sm text-muted-foreground mt-1">
                          <span>GPA: {edu?.gpa}</span>
                          {edu?.honors && (
                            <>
                              <span>•</span>
                              <span className="text-success">{edu?.honors}</span>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {edu?.description && (
                    <p className="text-muted-foreground mb-4">{edu?.description}</p>
                  )}

                  {edu?.coursework && (
                    <div>
                      <h5 className="font-medium text-foreground mb-2">Relevant Coursework:</h5>
                      <div className="flex flex-wrap gap-2">
                        {edu?.coursework?.map((course, index) => (
                          <span 
                            key={index}
                            className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full"
                          >
                            {course}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Certifications Section */}
          <div>
            <h3 className="text-2xl font-semibold text-foreground mb-6 flex items-center">
              <Icon name="Award" size={24} className="mr-3 text-primary" />
              Professional Certifications
            </h3>
            
            <div className="space-y-4">
              {certifications?.map((cert) => (
                <div key={cert?.id} className="bg-background rounded-xl p-6 border border-border shadow-subtle">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-start space-x-3">
                      <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                        <Image
                          src={cert?.logo}
                          alt={`${cert?.issuer} logo`}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <h4 className="font-semibold text-foreground mb-1">
                          {cert?.name}
                        </h4>
                        <p className="text-primary text-sm font-medium">{cert?.issuer}</p>
                      </div>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(cert?.status)}`}>
                      {cert?.status}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 gap-4 text-sm text-muted-foreground mb-4">
                    <div>
                      <span className="font-medium">Issued:</span> {cert?.issueDate}
                    </div>
                    <div>
                      <span className="font-medium">Expires:</span> {cert?.expiryDate}
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="text-xs text-muted-foreground">
                      <span className="font-medium">ID:</span> {cert?.credentialId}
                    </div>
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="ExternalLink"
                      iconPosition="right"
                      onClick={() => window.open(cert?.verificationUrl, '_blank')}
                    >
                      Verify
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationCertifications;